import { IRegion } from '@/creditflowresearch/domain/vo/Filters/IRegion';

const getRegionsByCountries = (
  countryIds: string[] = [],
  regionList: IRegion[],
): string[] => {
  const regionIds = new Set<string>();

  regionList.forEach((region) => {
    const isRegion = region.countryList.some((country) => countryIds.includes(country.countryId));

    if (isRegion) {
      regionIds.add(region.regionId);
    }
  });

  return [...regionIds];
};

export default getRegionsByCountries;
